export enum CopiedType {
    IA,
    CONVERGENCIA
}
